import Vue from "vue"
import Vapi from "vuex-rest-api"

const vouchers = new Vapi({
  axios: Vue.axios,
  queryParams: true,
  state: {
    voucher: null,
    vouchers: [],
    allVouchers: [],
    totalCost: null,
  },
})

  // vouchers
  .get({
    action: "listVouchers",
    property: "vouchers",
    path: ({ showId }) => `/vouchers/?show=${showId}`,
  })
  .get({
    action: "listAllVouchers",
    property: "allVouchers",
    path: ({ showId }) => `/vouchers/?show=${showId}&no_page=1`,
  })
  .post({
    action: "createVoucher",
    path: "/vouchers/",
  })
  .patch({
    action: "updateVoucher",
    path: ({ id }) => `/vouchers/${id}/`,
  })
  .delete({
    action: "destroyVoucher",
    path: ({ id }) => `/vouchers/${id}/`,
  })

  // finalize
  .getStore()

export default vouchers
